import { render, staticRenderFns } from "./labor.vue?vue&type=template&id=b9c9badc&scoped=true"
var script = {}
import style0 from "./labor.vue?vue&type=style&index=0&id=b9c9badc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c9badc",
  null
  
)

export default component.exports